import { CalendarTodayOutlined } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';

import { CopyButton } from '../../components/general/CopyButton';
import { LabelValue } from '../../components/general/LabelValue';
import { VivaStatusSwitchForDurchgang } from '../../components/general/VivaStatusSwitchForDurchgang.tsx';
import { geschaeftsbereiche, GetDurchgangByAkaDurchgangIdOutput } from '../../dtos';
import { getVeranstaltungTrainers, printTerminart, printWithNoInfo } from '../../utils';
import { formatZeitraumDate } from '../../utils/dateFormat/dateFormat.ts';
import { printMultiWo } from '../../utils/printWo.ts';
import { content } from './DurchgangDetailsHeader.content.tsx';

export const DurchgangDetailsHeader = ({ durchgang }: { readonly durchgang: GetDurchgangByAkaDurchgangIdOutput }) => {
  const trainers = getVeranstaltungTrainers(
    durchgang.modultermine.flatMap((modultermin) => modultermin.experteBlockungen),
  );
  const theme = useTheme();
  const { akaDurchgangId, durchgangSapId } = durchgang;
  const manuellerAusschreibungsprozess = durchgang.modultermine.some(
    (modultermin) => modultermin.manuellerAusschreibungsprozess,
  );

  return (
    <Box p={3} borderRadius={2} sx={{ background: theme.palette.surface.brandLight }}>
      <Box display="flex" gap={1} mb={3} height={32}>
        <CalendarTodayOutlined />
        <Typography variant="headingXs" sx={{ mr: 'auto' }}>
          {durchgang.titel}
        </Typography>
        <VivaStatusSwitchForDurchgang durchgang={durchgang} popperStyle={{ zIndex: theme.zIndex.appBar - 1 }} />
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(2, minmax(0, 1fr))" rowGap={1}>
        <LabelValue label={content.zeitraum} value={formatZeitraumDate(durchgang.zeitraum)} />
        <LabelValue
          label={content.sapId}
          value={
            durchgangSapId ? (
              <Box sx={{ '& button': { py: 0 }, display: 'flex', alignItems: 'center' }}>
                <Typography variant="labelLight">{durchgangSapId}</Typography>
                <CopyButton text={durchgangSapId.toString()} />
              </Box>
            ) : (
              '-'
            )
          }
        />
        <LabelValue
          label={trainers.length > 1 ? content.experten : content.experte}
          value={trainers.length > 0 ? trainers.join(', ') : '-'}
        />
        <LabelValue
          label={content.akaDurchgangId}
          value={
            <Box sx={{ '& button': { py: 0 }, display: 'flex', alignItems: 'center' }}>
              <Typography variant="labelLight">{akaDurchgangId}</Typography>
              <CopyButton text={akaDurchgangId} />
            </Box>
          }
        />
        <LabelValue label={content.wo} value={printWithNoInfo(printMultiWo(durchgang.modultermine))} />
        <LabelValue label={content.durchgangsart} value={printTerminart(durchgang.durchgangsart)} />
        <LabelValue
          label={content.geschaeftsbereich}
          value={durchgang.geschaeftsbereich === geschaeftsbereiche.UNKNOWN ? undefined : durchgang.geschaeftsbereich}
        />
        <LabelValue
          label={content.manuellerAusschreibungsprozess}
          value={manuellerAusschreibungsprozess ? 'Ja' : 'Nein'}
        />
      </Box>
    </Box>
  );
};
